import { makeStyles } from '@material-ui/core';
import { RoleIcon } from '../../core/themes/icons/RoleIcon';
import React from 'react';
import {
  Datagrid,
  List,
  Responsive,
  SimpleList,
  TextField,
  TopToolbar
} from 'react-admin';

import BulkActionDeleteButton from '../../core/components/BulkActionDeleteButton';
import Empty from '../../core/components/list/Empty';
import ListTitleBar from '../../core/components/ListTitleBar';
import LinkField from '../../core/components/LinkField';

const useStyles = makeStyles({
  dataGridHead: {
    '& tr': {
      '& th:nth-of-type(1)': {
        width: '24px'
      }
    }
  },
  statusColumnStyle: {
    width: '68px'
  },
  root: {
    marginRight: 'auto'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();
  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const RolesTitle = props => {
  return (
    <ListTitleBar
      type="Access Roles"
      title="New Access Role"
      createUrl="#/roles/create"
      icon={<RoleIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};
const RoleList = ({
  hasCreatePermission,
  hasDeletePermission,
  hasEditPermission,
  userProfile,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <List
      {...rest}
      title={<RolesTitle hasCreatePermission={hasCreatePermission} />}
      sort={{ field: 'description', order: 'ASC' }}
      pagination={
        <>
          <p />
        </>
      }
      exporter={false}
      bulkActionButtons={hasDeletePermission && <BulkActionDeleteButton />}
      actions={<Actions />}
      empty={<Empty />}
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.description}
            secondaryText={record => record.id}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid
            classes={{
              thead: hasDeletePermission && classes.dataGridHead
            }}
          >
            <LinkField
              label="Access Role Name"
              source="description"
              sortable={false}
            />
            <TextField label="Access Role ID" source="id" sortable={false} />
          </Datagrid>
        }
      />
    </List>
  );
};

export default RoleList;
